import React, { useEffect } from "react";
import { Route, Routes } from "react-router";
import {
  ApplicationContextProvider,
  BusinessLine,
  TokenValidation,
} from "./components/core";
import CampaignSelector from "./components/core/CampaignSelector";
import { ModalProvider } from "./components/common/ModalContext";

import Accessibility from "./components/modules/Accessibility";
import Failed from "./components/pages/Failed";
import GenericError from "./components/pages/GenericError";
import Home from "./components/pages/Home";
import Success from "./components/pages/Success";
import TokenExpired from "./components/pages/TokenExpired";
import Footer from "./components/template-parts/Footer";
import Navbar from "./components/template-parts/Navbar";
import "./custom.css";
import { createCookieScript } from "./functions/scriptUtils";
import { useBackground } from "./hooks/background";
import { useEnvironment } from "./hooks/useEnvironments";
import { AccessibilityProvider, useAccessibility } from "./components/modules/AccessibilityContext";

const AppContent: React.FC = () => {
  const env = useEnvironment();
  const { getAccessibilityClasses, getAccessibilityStyles } = useAccessibility();

  useEffect(() => {
    if (!env || !env.cookieScriptUrl) return;

    createCookieScript(env.cookieScriptUrl);
  }, [env]);

  const bgHook = useBackground(false);
  let bgContainerClasses = "app-container-bg";
  if (bgHook.fixedPage) {
    bgContainerClasses = bgContainerClasses + " fixed-page";
  }

  return (
    <div>
      <div
        className={`app-container ${getAccessibilityClasses()}`}
        style={getAccessibilityStyles()}
      >
        <div className={bgContainerClasses} />
        <ModalProvider>
          <ApplicationContextProvider bgHook={bgHook}>
            <Navbar />
            <Routes>
              <Route path="/token/:token" element={<TokenValidation />} />
              <Route path="/:businessLine/token/:token" element={<BusinessLine environment={env || undefined} />}>
                <Route path="authentication" element={<Home />} />
                <Route path="success" element={<Success />} />
                <Route path="token-expired" element={<TokenExpired />} />
                <Route path="custom-error" element={<Failed />} />
                <Route path=":campaign/complete" element={<CampaignSelector />} />
              </Route>
              <Route path="/default-error" element={<GenericError />} />
              <Route path="*" element={<GenericError />} />
            </Routes>
            <Footer />
          </ApplicationContextProvider>
        </ModalProvider>
      </div>
      <Accessibility />
    </div>
  );
};

const App: React.FC = () => {
  return (
    <AccessibilityProvider>
      <AppContent />
    </AccessibilityProvider>
  );
};

export default App;
